import * as React from "react";
import { IconProps } from "./types";

export const ArrowCircleBrokenUpLeftIcon = React.forwardRef<
  SVGSVGElement,
  IconProps
>(({ color = "currentColor", ...props }, forwardedRef) => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M14.5895 21.6606C11.2533 22.5515 7.54616 21.6884 4.92887 19.0711C1.02363 15.1658 1.02363 8.83418 4.92887 4.92893C8.83411 1.02369 15.1658 1.02369 19.071 4.92893C21.6883 7.54623 22.5515 11.2534 21.6606 14.5896M9.00017 15.0001V9.0001M9.00017 9.0001H15.0002M9.00017 9.0001L19 19"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        stroke={color}
      />
    </svg>
  );
});
(ArrowCircleBrokenUpLeftIcon as React.FunctionComponent).displayName =
  "ArrowCircleBrokenUpLeftIcon";

export default ArrowCircleBrokenUpLeftIcon;
